import {
    createAsyncThunk
} from '@reduxjs/toolkit';
import axios from 'axios';
import {
    api
} from '../../helpers/api_helper';
import Log from '../../Services/Log';
import { API_ENDPOINTS } from '../../constants/apiEndPoints';


export const getWorks = createAsyncThunk('works/getAll', async ({page, limit }, thunkAPI) => {
    try {
        const response = await api.get(API_ENDPOINTS.WORKS.GET_ALL, {
            limit,
            page
        });
        return response.data;
    } catch (error) {
        return thunkAPI.rejectWithValue(error.response.data);
    }
});

export const addWorks = createAsyncThunk('works/add', async (uploadedImage, thunkAPI) => {
    try {
        const response = await api.create(API_ENDPOINTS.WORKS.ADD, {
            files: uploadedImage
        });
        return response.data;
    } catch (error) {
        return thunkAPI.rejectWithValue(error.response.data);
    }
});

export const deleteWorks = createAsyncThunk('works/delete', async (ids, thunkAPI) => {
    try {
        const response = await api.delete(API_ENDPOINTS.WORKS.DELETE, {
            data: { ids }
        });
        // if (!response.ok) {
        //     throw new Error('Failed to delete the catalogue');
        // }
        return ids;
    } catch (error) {
        return thunkAPI.rejectWithValue(error.message);
    }
});